<template>
  <div id="dashboard">
    <section :class="{'pl-0': $mq.isDesktop()}">
      <div class="section-content with-shadow">
        <div class="flex wrap top-panel">
          <div>
            <div class="label">
              <template v-if="order && order.is_ok">
                <h2>Completa la tua spesa</h2>
                <i class="fas fa-check" />&nbsp;
                <span>Aggiungi altri prodotti al tuo carrello oppure vai alla cassa.</span>
              </template>
              <!--<template v-if="order && order.status_payment == 'unpaid'">
								<i class="fas fa-exclamation-triangle" /> Ops... il pagamento non è andato a buon fine! <b>Ricarica o sostituisci la carta</b> per ricevere queste fantastiche ricette <b>entro {{ dateProcessment }}</b>.
							</template>-->
              <template v-else-if="lastOrder && lastOrder.is_pending">
                <h2>Il tuo ordine</h2>
                <i class="fas fa-check" />&nbsp;
                <span>Puoi modificarlo entro le 23:00 di {{dateCutOff}}</span>
              </template>
              <template v-else>
                <h2>Il menu della settimana</h2>
                Ecco il menù di questa settimana! Fai ora la tua prossima spesa
                a casa.
              </template>
            </div>
          </div>

          <div class="flex-left pb-5" v-if="lastOrder && lastOrder.is_pending">
            <!-- <div  v-if="order.plan.meals > 0">
							<img src="../../assets/img/badges/home/fork.png" class="icon" width="20"> Piano: <b>Food Box per {{ order.plan.people }} persone</b>
						</div> -->

            <div>
              <img
                src="../../assets/img/badges/plans/delivery-grey.png"
                width="20"
                class="icon delivery-icon"
              />
              Data di consegna:
              <b>{{ $_dates_readableDate(lastOrder.date.delivery) }}</b>
            </div>
          </div>
        </div>

        <div class="recipes">
          <keep-alive>
            <SliderQ
              :maxNumSlides="6"
              :minSizeOfSlide="150"
              v-if="sliderSrc && sliderSrc.length > 0"
            >
              <slide v-for="(item, index) in sliderSrc" :key="index">
                <small-item-box
                  v-if="activeOrder"
                  :itemTitle="item.title + quantityType(item) + quantity(item)"
                  :itemImage="
                    item.images
                      ? item.images.small
                        ? item.images.small
                        : item.images.big
                      : ''
                  "
                />
                <small-item-box
                  v-if="!activeOrder"
                  :itemTitle="item.title"
                  :itemImage="
                    item.images
                      ? item.images.small
                        ? item.images.small
                        : item.images.big
                      : ''
                  "
                />
              </slide>
            </SliderQ>
          </keep-alive>

          <keep-alive>
            <SliderQ
              :maxNumSlides="6"
              :minSizeOfSlide="150"
              v-if="!sliderSrc || sliderSrc.length <= 0"
            >
              <slide v-for="i in 6" :key="i">
                <loading-placeholder
                  class="shadow-box"
                  :lines="2"
                  :lineSize="10"
                />
              </slide>
            </SliderQ>
          </keep-alive>
        </div>

        <br />

        <!--<div>
					<p v-if="noOrderButNotSuspended">
						Se non desideri ordinare ricorda di saltare la consegna, in alternativa ti sarà inviato un box secondo l'ultimo piano da te scelto.
					</p>
					<p v-if="noOrderButSuspended && !isMenuClosed">
						{{ user.subscription.is_suspended
							? ''
							: 'La prossima consegna è stata saltata'
						}}
					</p>
					<p v-if="noOrderButSuspended && isMenuClosed">
						Il tuo abbonamento è sospeso, potrai scegliere nuove ricette lunedì.
					</p>
				</div>-->
        <div>
          <div class="button-group flex-vcenter wrap">
            <template v-if="order && order.is_ok">
              <router-link :to="{ name: 'verify-page' }">
                <CTA :content="`Vai alla cassa`" />
              </router-link>
            </template>

            <template v-else-if="lastOrder && lastOrder.is_pending">
              <router-link :to="{ name: 'profile_orders' }">
                <CTA :content="`Rivedi l'ordine`"/>
              </router-link>
              <span class="choose-action" :class="[!$mq.isDesktop() ? ''  : 'px-3']">oppure</span>
              <router-link :to="{ name: 'recipes'}">
                <CTA :content="`Crea nuovo ordine`" />
              </router-link>
            </template>

            <template v-else>
              <CTA
                :content="`Fai la tua spesa`"
                isArrow
                @click="goToCheckout()"
                v-if="!isMenuClosed"
              />

              <CTA
                :content="`Guarda il prossimo menu`"
                isArrow
                @click="goToRecipes()"
                v-if="isMenuClosed"
              />
            </template>

		<!-- 	<template v-if="activeOrder && unPaidOrder">
              <router-link :to="{ name: 'verify-page' }">
                <CTA :content="`Modifica Ordine`" />
              </router-link>
            </template>

            <template v-if="unpaidOrder">
              <CTA
                :content="`Modifica metodo di pagamento`"
                @click="goToPayment()"
                v-if="!isPaymentClosed"
              />
            </template>
            <template v-if="suspendedOrSkipped && !orderClosed">
              <CTA
                isWithLoader
                content="Riattiva la consegna"
                v-if="skippedOrder && !suspendedAbo"
                @click="goToCheckout()"
                :loading="updating"
              />
              <CTA
                isWithLoader
                content="Fai la tua spesa"
                v-if="suspendedAbo"
                @click="goToCheckout()"
                :loading="updating"
              />
              <flash :flash="error" :state="state" />
            </template> -->
          </div>
          <div
            class="flex-right center"
            v-if="(suspendedOrSkipped || noOrder) && discount"
          >
            <b>Hai uno sconto di {{ discount.amount}}{{ discount.unit | unit }} che ti aspetta!</b>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { scrollToElementId } from "../../assets/js/main";
import { WeekPlanApi } from "../../api/WeekPlanApi";
import { UserApi } from "../../api/UserApi";

import { subscription } from "../../mixins/subscriptionActions";
import { dashboard } from "../../mixins/dashboard";
import { dates } from "../../mixins/dates";

import SmallItemBox from "../Parts/SmallItemBox";
import Flash from "../Parts/Flash";

import CTA from "../Elements/CTA";
import WidgetPlaceholder from "../WidgetPlaceholder";

import { menuStore } from "../../store/menuStore";
import { errorStore } from "../../store/errorStore";
import { subscriptionStore } from "../../store/subscriptionStore";

const moment = require("moment");

export default {
  props: {
    lastOrder: {
			type: Object,
			default() {
				return null
			}
		}
  },

  data() {
    return {
      recipes: null,
      updating: false,
      loadingOrder: true,
      nextWeekRecipes: [],
      discount: null,
      error: null,
      state: null,

      menuStore: menuStore.state,
      errorStore: errorStore.state,
      subscriptionStore: subscriptionStore.state,
    };
  },

  mixins: [subscription, dashboard, dates],

  components: {
    WidgetPlaceholder,
    SmallItemBox,
    Flash,
    CTA,
  },

  filters: {
    unit(val) {
      if (val === "i") return " €";
      if (val === "%") return "%";
      return "";
    },
  },

  watch: {
    "menuStore.active": {
      handler() {
        if (this.menu && !this.menu.active) {
          this.loadNextMenu();
        }
      },
      immediate: true,
    },
  },

  computed: {
    orderType() {
      return {
        "only-recipes":
          this.order.recipes.length >= 1 &&
          !this.order.recipes.find((recipe) =>
            recipe.name.toLowerCase().includes("cassetta")
          ),
        mixed:
          this.order.recipes.length > 1 &&
          this.order.recipes.find((recipe) =>
            recipe.name.toLowerCase().includes("cassetta")
          ),
        "one-item": this.order.recipes.length === 1,
      };
    },
    user() {
      return this.$root.user;
    },
    order() {
      return this.user.order;
    },
    menu() {
      return this.menuStore.menu;
    },
    sliderSrc() {
      if(this.order && this.order.is_ok) {
        return this.orderItems(this.order)
      } else if (this.lastOrder && this.lastOrder.is_pending) {
        return this.orderItems(this.lastOrder)
      } else if(this.isMenuUnavailable) {
        return this.nextWeekRecipes;
      }else {
        return this.menuRecipes
      }
    },

    menuRecipes() {
      if (!this.menu) return [];
      return this.menu && this.menu.recipes;
    },
    dateProcessment() {
      return "le 14:00 di " + this.$_dates_thisWeekDay(5);
    },

    isPaymentClosed() {
      var fridayAfter14 = moment()
        .day(5)
        .hour(13)
        .locale("it")
        .format();
      var now = moment()
        .locale("it")
        .format();
      return now > fridayAfter14;
    },
    isMenuClosed() {
      return !this.user.order && this.menu && !this.menu.first_available;
    },
    isMenuUnavailable() {
      return !this.user.order && this.menu && !this.menu.active;
    },
		dateCutOff () {
	    	return this.$_dates_readableDate(this.lastOrder.date.cutoff)
	    },
  },

  methods: {
    loadWeekById(id) {
      var weekApi = new WeekPlanApi();
      return weekApi
        .week({ id: id })

        .then((response) => {
          this.nextWeekRecipes = response.body.data.resource.recipes;
        });
    },

    scrollToDivId(target) {
      scrollToElementId(target);
    },

    goToCheckout() {
      this.$router.push({ name: "flow-subscribed" });
    },

    goToRecipes() {
      this.$router.push({ name: "recipes" });
    },

    goToPayment() {
      this.$router.push({ name: "profile_payment" });
    },

    $_subscription_beforeAction() {
      this.updating = true;
    },

    $_subscription_afterAction() {
      this.updating = false;
    },

    $_subscription_catchError(response) {
      this.error = errorStore.format(response);
      this.state = "error";

      this.updating = false;
    },

    resumeAboAndOrder() {
      this.$_subscription_resume()

        .then((response) => {
          this.$_subscription_calendar(this.user.order.week_plan, "active");
        })

        .catch((response) => {});
    },

    loadNextMenu() {
      var wm = new WeekPlanApi();
      wm.next({})
        .then((response) => {
          this.nextWeekRecipes = response.body.data.resource.recipes;

          if (!response.body.data.resource.active) {
            this.loadWeekById(231);
          }
        })

        .catch((response) => {});
    },

    loadActiveDiscount() {
      var um = new UserApi();
      um.discount().then((response) => {
        this.discount = response.body.resources[0];
      });
    },

    quantity(item) {
      if (item.cg1) {
        return item.quantity;
      } else {
        return item.quantity * 2;
      }
    },

    quantityType(item) {
      if (item.cg1) {
        return " Qt ";
      } else {
        return " Porz. ";
      }
    },

    orderItems(order) {
      return order.recipes.concat(order.extras);
    }
  },

  mounted() {
    menuStore.loadCurrentMenu();

    subscriptionStore.getCalendar({
      token: this.user.subscription.token,
    });

    if (this.user.order && this.user.order.closed) {
      this.loadNextMenu();
    }

    if (this.suspendedOrSkipped || this.noOrder) {
      this.loadActiveDiscount();
    }

    this.$_dates_loadDelivery();
  },
};
</script>

<style scoped>
.section-content {
  padding: 30px 50px;
  background: white;
}

#dashboard {
  padding-top: 20px;
  text-align: left;
  position: relative;
  background: var(--quomi-bg);
}

.top-panel > div:first-child {
  flex-grow: 1;
  margin-bottom: 20px;
}

.fa-check {
  color: var(--quomi-primary);
}

.top-panel .flex-right div {
  padding-bottom: 5px;
}

.delivery-icon {
  margin-bottom: 7px;
}

.recipes {
  margin: 0 -10px;
}

.button-group >>> .btn {
  margin-right: 5px;
}

@media (max-width: 800px) {
  .top-panel > div {
    flex-basis: 100%;
    text-align: left;
  }

  .choose-action {
    margin: auto;
  }
}

@media (max-width: 1024px) {
  #dashboard {
    padding-top: 0;
  }
  #dashboard section {
    padding: 0;
  }

  .button-group a {
    flex-basis: 100%;
  }
}
</style>
